import { useEffect, useState } from 'react';
import './style.scss';

import { TranslationService } from '../../../services/translation.service';

function Spinner({ text, delayInMs, className }: { text?: string | undefined; delayInMs?: number | undefined; className?: string | undefined }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const n = delayInMs !== 0 ? window.setTimeout(() => setVisible(true), delayInMs ?? 1000) : null;
    return () => {
      if (n) clearTimeout(n);
    };
  }, [delayInMs]);

  if (delayInMs !== 0 && !visible) {
    return null;
  }

  return (
    <div className={`d-flex flex-column align-items-center justify-content-center pt-3 ${className ?? ''}`}>
      <div className="dot-typing mb-2" />
      <div>
        {text ?? TranslationService.get('common.loadingdata')}
        ...
      </div>
    </div>
  );
}

export default Spinner;
